import React from 'react';
import { makeStyles, ButtonBase } from '@material-ui/core';
import AfitdTypography from '../../common/elemental/AfitdTypography';

const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {
            [theme.breakpoints.up('lg')]: { marginRight: 30 },
            [theme.breakpoints.up('md') && theme.breakpoints.down('md')]: { marginRight: 24 },
            [theme.breakpoints.down('sm')]: { marginRight: 0 },
            borderBottom: '4px solid #fafafa',
            color: '#111E14',
            '&:hover': {
                cursor: 'pointer',
                color: '#1D8A8B',
                borderBottom: '4px solid #1D8A8B',
            },
        },
        selected: {
            [theme.breakpoints.up('lg')]: { marginRight: 30 },
            [theme.breakpoints.up('md') && theme.breakpoints.down('md')]: { marginRight: 24 },
            [theme.breakpoints.down('sm')]: { marginRight: 0 },
            // borderBottom: '4px solid #fafafa',
            cursor: 'pointer',
            color: '#1D8A8B',
            borderBottom: '4px solid #1D8A8B',
        },
        button: {
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '500',
        },
        text: {
            display: 'flex',
            alignItems: 'center',
            height: '76px',
            [theme.breakpoints.down('sm')]: { height: '50px' },
            // [theme.breakpoints.up('md') && theme.breakpoints.down('md')]: { height: '50px' },
            textDecoration: 'none',
            color: '#111E14',
            '&:hover': {
                cursor: 'pointer',
                color: '#1D8A8B',
            },
        },
    }));
};

const TopNavButton = props => {
    const { isHidden, children, label, startIcon, isSelected, ...otherProps } = props;
    const classes = useStyles(/* {param1, param2} */)();

    const textDefn = {
        variant: 'body1',
        clsLightBold: true,
        className: classes.text,
        value: label,
    };

    if (isHidden) {
        return null;
    } else if (isSelected) {
        return (
            <div className={classes.selected}>
                <ButtonBase className={classes.button} {...otherProps}>
                    {startIcon}
                    <AfitdTypography {...textDefn} />
                </ButtonBase>
            </div>
        );
    } else {
        return (
            <div className={classes.root}>
                <ButtonBase className={classes.button} {...otherProps}>
                    {startIcon}
                    <AfitdTypography {...textDefn} />
                </ButtonBase>
            </div>
        );
    }
};

export default TopNavButton;
